// Deployed environments set the token cookie under the `__Host-` prefix, local
// development under the plain name. Read in this order so the prefixed cookie
// wins wherever both happen to be present.
export const CSRF_COOKIE_NAMES = ['__Host-csrftoken', 'csrftoken'];

export const CSRF_HEADER_NAME = 'X-CSRFToken';
